import { defineComponent as _defineComponent } from 'vue'
import { decodeMessageText } from '../util';


export default /*#__PURE__*/_defineComponent({
  __name: 'MessageText',
  props: ['data'],
  setup(__props) {

const props = __props;



const handleTextMessageShowContext = (text: string) => decodeMessageText(text);

return { __sfc: true,props, handleTextMessageShowContext }
}

})